<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-block z-1">
            <IncomingPayments :projectId="id"></IncomingPayments>
          </div>
          <div class="card-block">
            <Invoices :projectId="id"></Invoices>
          </div>
        </div>
      </div>
      <!--/.col-->
    </div>
    <!--/.row-->
  </div>
</template>
<style lang="scss" scoped>
.z-0 {
  z-index: 0;
}

.z-1 {
  z-index: 1;
}

.card-block-mb {
  padding-bottom: 0px;
}
</style>

<script>
import { mapGetters, mapActions } from 'vuex';
//     import {GoogleCharts} from 'google-charts';
// import moment from 'moment';
import IncomingPayments from './IncomingPayments';
import Invoices from '../documents/Invoices';

export default {
  name: 'ProjectTabInvoicesPayments',
  components: {
    IncomingPayments,
    Invoices
  },
  data: function () {
    return {
      // id: this.$route.params.id,
    };
  },
  props: {
    id: { type: Number }
  },
  watch: {
  },
  computed: {
    ...mapGetters('JiraProjects', ['projects']),
  },
  methods: {
  },
  created() {
  },
  mounted() {
  },
};
</script>
